import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { SelectItem, Message } from 'primeng';
import { NoEmptyString } from '../../interfaces/no-empty-string.validator';
import { ITruckForm } from '../../interfaces/truck-form';
import { ITrucks } from '../../interfaces/trucks';
import { IUserOrganisationLevel } from '../../interfaces/user-organisation-level';
import { BBWTMessageService, OrganisationsService } from '../../services';
import { SupplierService } from '../../services';
import { TrucksService } from '../../services';

@Component({
  templateUrl: './truck-details.component.html',
  styleUrls: [`./truck-details.component.scss`],
})
export class TruckDetailsComponent implements OnInit {
  constructor(
    private trucksService: TrucksService,
    private route: ActivatedRoute,
    private router: Router,
    private supplierService: SupplierService,
    private organisationsService: OrganisationsService,
    private messageService: BBWTMessageService,
  ) {}

  public truckdata: ITrucks;
  public truck: ITruckForm;
  public newTruckForm: UntypedFormGroup;
  public id: number;
  l_msgs: Message[] = [];
  public uLevel: IUserOrganisationLevel;
  truckTypes: SelectItem[];

  depots: SelectItem[];
  regions: SelectItem[];
  selectedRegion: any;
  public searchingDepots: boolean = false;
  public accessDetail: any = null;

  ngOnInit() {
    this.getTruckTypes();

    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
    });

    // set formGroup instance
    this.truck = {
      id: 0,
      regionId: new UntypedFormControl(''),
      depotId: new UntypedFormControl(''),
      typeId: new UntypedFormControl(''),
      assetNumber: new UntypedFormControl('', Validators.required),
      capacity: new UntypedFormControl(''),
      capacityTowing: new UntypedFormControl(''),
      description: new UntypedFormControl(''),
      registration: new UntypedFormControl('', Validators.required),
      make: new UntypedFormControl('', Validators.required),
      model: new UntypedFormControl('', Validators.required),
    };

    this.newTruckForm = new UntypedFormGroup({
      regionId: this.truck.regionId,
      depotId: this.truck.depotId,
      typeId: this.truck.typeId,
      assetNumber: this.truck.assetNumber,
      registration: this.truck.registration,
      capacity: this.truck.capacity,
      capacityTowing: this.truck.capacityTowing,
      description: this.truck.description,
      make: this.truck.make,
      model: this.truck.model,
    });

    this.trucksService
      .getAccessDetails(this.id)
      .then((x) => {
        this.accessDetail = x;
        if (this.accessDetail && this.accessDetail.hasAccess) {
          //level settings
          this.organisationsService.getUserOrganisationLevel().then((resp) => {
            this.uLevel = resp;
            this.updateRegionAndDepotLists();
          });

          //get current truck
          this.trucksService.get(this.id).then((resp) => {
            this.truckdata = resp;
            this.setFormGroupValues();
            this.updateRegionAndDepotLists();
          });
        }
      })
      .catch((err) => {
        this.accessDetail = { hasAccess: false };
      });
  }

  updateRegionAndDepotLists() {
    if (this.uLevel && this.truckdata) {
      if (this.uLevel.isAllDepots) {
        this.truck.regionId.setValidators(Validators.required);
        this.truck.depotId.setValidators(Validators.required);

        this.getRegions(this.truckdata.depot.regionId);
        this.getDepots(this.truckdata.depot.regionId, this.truckdata.depotId);
      } else if (this.uLevel.isCertainDepots) {
        this.truck.depotId.setValidators(Validators.required);

        this.getDepots(this.truckdata.depot.regionId, this.truckdata.depotId);
      }
    }
  }

  setFormGroupValues() {
    const regexpAllIsIs = new RegExp(/^\d+$/);
    // set formGroup instance
    this.truck = {
      id: 0,
      regionId: new UntypedFormControl(this.truckdata.depot.regionId),
      depotId: new UntypedFormControl(this.truckdata.depotId),
      typeId: new UntypedFormControl(this.truckdata.typeId),
      assetNumber: new UntypedFormControl(
        this.truckdata.assetNumber,
        Validators.compose([Validators.required, Validators.maxLength(20), NoEmptyString]),
      ),
      capacity: new UntypedFormControl(
        this.truckdata.capacity,
        Validators.compose([
          Validators.pattern(regexpAllIsIs),
          Validators.min(0),
          Validators.max(1000000),
        ]),
      ),
      capacityTowing: new UntypedFormControl(
        this.truckdata.capacityTowing,
        Validators.compose([
          Validators.pattern(regexpAllIsIs),
          Validators.min(0),
          Validators.max(1000000),
        ]),
      ),
      description: new UntypedFormControl(
        this.truckdata.description,
        Validators.compose([null, Validators.maxLength(100), NoEmptyString]),
      ),
      registration: new UntypedFormControl(
        this.truckdata.registration,
        Validators.compose([Validators.required, Validators.minLength(2), Validators.maxLength(8)]),
      ),
      make: new UntypedFormControl(
        this.truckdata.make,
        Validators.compose([null, Validators.maxLength(100), NoEmptyString]),
      ),
      model: new UntypedFormControl(
        this.truckdata.model,
        Validators.compose([null, Validators.maxLength(100), NoEmptyString]),
      ),
    };

    this.newTruckForm = new UntypedFormGroup({
      regionId: this.truck.regionId,
      depotId: this.truck.depotId,
      typeId: this.truck.typeId,
      assetNumber: this.truck.assetNumber,
      capacity: this.truck.capacity,
      capacityTowing: this.truck.capacityTowing,
      description: this.truck.description,
      registration: this.truck.registration,
      make: this.truck.make,
      model: this.truck.model,
    });
  }
  save(formValues) {
    var obj = {
      id: this.id,
      regionId: formValues.regionId || 0,
      depotId: formValues.depotId || 0,
      typeId: formValues.typeId,
      assetNumber: formValues.assetNumber,
      capacity: formValues.capacity,
      capacityTowing: formValues.capacityTowing,
      description: formValues.description,
      make: formValues.make,
      model: formValues.model,
      registration: formValues.registration,
      depot: null,
    };

    this.trucksService
      .update(this.id, obj)
      .then((res) => {
        this.router.navigate(['app/trucks']);
      })
      .catch((error) => {
        if (error?.error?.message?.includes('This truck already exists')) {
          this.messageService.ShowError('Error', 'This truck already exists', 3);
        } else {
          this.messageService.ShowError('Error', 'Details not saved', 3);
        }
      });
  }
  getRegions(selectedRegionId: number) {
    this.supplierService.getRegions().then((result) => {
      var allRegions = [];
      if (this.uLevel.isAllDepots) {
        allRegions = result;
      } else if (this.uLevel.isCertainDepots) {
        allRegions = result.filter((x) => this.uLevel.regionId.indexOf(x.id) > -1);
      }

      this.regions = [];
      if (allRegions != null) {
        allRegions.forEach((item) => {
          this.regions.push({ label: item.name, value: item.id });
        });
      }

      this.truck.regionId.setValue(selectedRegionId);
    });
  }

  getDepots(regionId: number, selectedDepotId: number) {
    this.searchingDepots = true;

    this.supplierService.getDepots(regionId).then((result) => {
      var allDepots = [];
      if (this.uLevel.isAllDepots) {
        allDepots = result;
      } else if (this.uLevel.isCertainDepots) {
        allDepots = result.filter(
          (x) => this.uLevel.depotId.filter((t) => t.id == x.id).length != 0,
        );
      }

      this.depots = [];
      if (allDepots != null) {
        allDepots.forEach((item) => {
          this.depots.push({ label: item.name, value: item.id });
        });
      }
      this.searchingDepots = false;

      this.truck.depotId.setValue(selectedDepotId);
    });
  }

  onRegionChange(eventValue: any) {
    this.getDepots(eventValue, null);
  }

  getTruckTypes() {
    this.trucksService.getTruckTypes().then((result) => {
      this.truckTypes = [];
      if (result != null) {
        result.forEach((item) => {
          this.truckTypes.push({ label: item.name, value: item.id });
        });
      }
    });
  }

  Cancel() {
    this.router.navigate(['app/trucks']);
  }

  limitCapacity(element) {
    var max_chars = 7;
    if (element.srcElement.value.length > max_chars) {
      this.newTruckForm.patchValue({
        capacity: element.srcElement.value.substr(0, max_chars),
      });
    }
  }

  limitCapacityTowing(element) {
    var max_chars = 7;
    if (element.srcElement.value.length > max_chars) {
      this.newTruckForm.patchValue({
        capacityTowing: element.srcElement.value.substr(0, max_chars),
      });
    }
  }
}
